import React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58 69"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="c">
        <stop stopColor="#94D87B" offset="0%" />
        <stop stopColor="#67B85B" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="b">
        <stop stopColor="#B1E89D" offset="0%" />
        <stop stopColor="#92CD89" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="15.471%"
        y1="14.721%"
        x2="90.626%"
        y2="87.999%"
        id="e"
      >
        <stop stopColor="#ECF7E8" offset="0%" />
        <stop stopColor="#ECF7E8" offset="100%" />
      </linearGradient>
      <filter
        x="-44%"
        y="-37%"
        width="187.9%"
        height="173.9%"
        filterUnits="objectBoundingBox"
        id="a"
      >
        <feOffset dy={3} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter
        x="-49.2%"
        y="-48.9%"
        width="198.4%"
        height="197.8%"
        filterUnits="objectBoundingBox"
        id="d"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={2}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.415686275 0 0 0 0 0.729411765 0 0 0 0 0.364705882 0 0 0 1 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#a)" fill="none" fillRule="evenodd">
      <path
        d="M29 4c6.35 0 12.1 2.59 16.261 6.774A23.132 23.132 0 0 1 52 27.136c0 5.526-3.422 12.305-7.652 18.275C38.784 53.26 31.73 60 29 60c-2.73 0-9.784-6.74-15.348-14.59C9.422 39.442 6 32.663 6 27.137c0-6.39 2.575-12.174 6.739-16.362C16.9 6.59 22.649 4 29 4Z"
        stroke="url(#b)"
        strokeWidth={2}
        fill="url(#c)"
      />
      <g
        filter="url(#d)"
        transform="translate(16.8 13.437)"
        fill="url(#e)"
        fillRule="nonzero"
      >
        <path d="M24.293 10.041a10.66 10.66 0 0 0-2.7-2.165A12.335 12.335 0 0 0 17.54 6.43a12.48 12.48 0 0 0-.966-.13 12.7 12.7 0 0 0-5.555.672 35.94 35.94 0 0 0 2.232-2.184c1.788-1.915 2.935-3.613 3.444-4.427.149-.237-.168-.43-.551-.34a15.61 15.61 0 0 0-3.102 1.066c-1.07.5-2.021 1.117-2.811 1.84-.17.153-.33.313-.484.477-.971 1.038-1.545 2.187-1.731 3.357-.603-.743-1.46-1.241-2.534-1.428a5.332 5.332 0 0 0-.458-.06c-.727-.067-1.516-.003-2.344.18-.743.16-1.532.42-2.348.776-.286.124-.433.39-.253.464.621.257 1.984.755 3.845 1.078.653.114 1.281.19 1.856.242-.967.335-1.869.945-2.617 1.85-.162.197-.314.4-.45.613-.649.997-1.023 2.142-1.134 3.34a8.415 8.415 0 0 0 .258 3.014c.087.322.515.475.752.277a27.92 27.92 0 0 0 3.857-3.949 27.587 27.587 0 0 0 2.08-3.026c.53.436 1.026.906 1.49 1.409 2.153 2.314 3.492 5.294 3.691 8.558h-.082c-3.881 0-7.335 1.596-9.54 4.438H23.17c-1.044-1.435-2.355-2.337-3.868-3.094a12.57 12.57 0 0 0-.607-.288 13.707 13.707 0 0 0-3.147-8.233 16.746 16.746 0 0 0-2.986-2.845 53.92 53.92 0 0 0 3.546.469c3.453.338 6.388.266 7.804.195.415-.02.632-.419.38-.7" />
      </g>
    </g>
  </svg>
)

export default SvgComponent
